import React, { useContext, useEffect } from "react";
import styles from "./BrainList.module.css";
import BrainCard from "./BrainCard";
import { KnowledgeType } from "../../../../../util/KnowledgeType";
import SopCard from "./SopCard";
import IntentCard from "./tabs/intent/components/IntentCard";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../store/common/hooks";
import { AuthContext } from "../../../../../context/AuthContext";
import { fetchIntents } from "../../../../../store/intent.slice";
import { fetchSopKnowledge } from "../../../../../store/sop.slice";
import { showConsoleError } from "../../../../../util/ConsoleMessage";
import { fetchBrainList } from "../../../../../store/brain.slice";

interface BrainList {}

const BrainList: React.FC<BrainList> = ({}) => {
  const dispatch = useAppDispatch();
  const knowledgeType = useAppSelector((s) => s.brain.knowledgeType);
  const brainList = useAppSelector((s) => s.brain.list);
  const intentList = useAppSelector((s) => s.intent.items);
  const sopList = useAppSelector((s) => s.sop.items);

  const { isSignedIn } = useContext(AuthContext);

  useEffect(() => {
    try {
      if (!isSignedIn) return;

      if (knowledgeType === KnowledgeType.SOP) {
        dispatch(fetchSopKnowledge());
      } else if (knowledgeType === KnowledgeType.INTENT) {
        dispatch(fetchIntents());
      } else {
        dispatch(fetchBrainList());
      }
    } catch (e) {
      showConsoleError("API Response:Error", e);
    }
  }, [knowledgeType]);

  return (
    <div className={styles["question-group-scroll-container"]}>
      {knowledgeType === KnowledgeType.SOP ? (
        <>
          {sopList &&
            sopList.map((brain) => <SopCard key={brain.id} data={brain} />)}
        </>
      ) : knowledgeType === KnowledgeType.INTENT ? (
        intentList &&
        intentList.map((intent) => (
          <IntentCard key={intent.id} intent={intent} />
        ))
      ) : (
        <>
          {brainList &&
            brainList.map((brain) => <BrainCard key={brain.id} data={brain} />)}
        </>
      )}
    </div>
  );
};

export default BrainList;
